<template>
  <div class="container-fluid newsletterBlock">
    <div id="mc_embed_signup">
      <form action="//wenatur.us14.list-manage.com/subscribe/post?u=5bbbff8514d7356d892d021e8&amp;id=9fd05b1835" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate mailingList" target="_blank" novalidate>
        <div class="row">
          <div class="col-md-4">
            <div class="description">Keep up with new activities, signup for our newsletter</div>
          </div>
          <div class="col-md-4">
            <div id="mc_embed_signup_scroll">
              <div class="mc-field-group">
                <input placeholder="your email" type="email" value="" name="EMAIL" class="required email" id="mce-EMAIL">
              </div>
              <div id="mce-responses" class="clear">
                <div class="response" id="mce-error-response" style="display:none"></div>
                <div class="response" id="mce-success-response" style="display:none"></div>
              </div>    <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
              <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_5bbbff8514d7356d892d021e8_9fd05b1835" tabindex="-1" value=""></div>
            </div>
          </div>

          <div class="col-md-4 submitBlock">
            <input type="submit" value="sign up" name="subscribe" id="mc-embedded-subscribe" class="button btn btn-primary">
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

</template>

  <script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'Newsletter',
  computed: {
    ...mapState({

    }),
  },
  methods: {
    ...mapActions({

    }),
  },
};

</script>


  <style lang="scss" scoped>
.container-fluid {
  margin-left: 0;
  margin-right: 0;
  padding-left: 0;
  padding-right: 0;
  box-sizing: border-box;
}
form {
  padding: 6px 15px 6px;
  background-color: rgb(0, 130, 97);
  color: white;
}
.description {
  line-height: 40px;
}
.submitBlock {
  text-align: center;
}
.newsletterBlock {
  input[type="email"] {
    color: white !important;
  }

  input[type="email"]::placeholder {
    color: white !important;
  }
}

</style>




// WEBPACK FOOTER //
// Newsletter.vue?799ae398